import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ErrorMessageResolver} from '../../error/errorMessage.resolver';

@Component({
  selector: 'app-error-text',
  templateUrl: './error-text.component.html',
})
export class ErrorTextComponent implements OnChanges{

  constructor(private errorMessageResolver: ErrorMessageResolver) {

  }

  @Input() error: any;
  @Input('message') inputMessage: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['error'] && this.error) {
      console.error(this.error);
    }
    if (changes['inputMessage'] && this.inputMessage) {
      console.error(this.inputMessage);
    }
  }




  get message(): string {
    if (this.inputMessage) {
      return this.inputMessage;
    }

    return this.errorMessageResolver.resolveError(this.error);
  }
}
